import ListResult from '../homepage/featured/listing';
import {listView} from '../shared/util';
import PropTypes from 'prop-types';
import React from 'react';

const ListView = ({results}) => {
  let listItems = [];
  results.forEach(function (result, index) {
    listItems.push(<ListResult listing={result} key={index} index={index} options={listView}/>);
  });
  return (
    <div className="featured-listings">
      <div className="container results-view">
        <div className="row">
        {listItems}
        </div>
      </div>
    </div>
  );
}

ListView.propTypes = {
  results: PropTypes.array.isRequired
};

export default ListView;



// WEBPACK FOOTER //
// ./src/components/search/list-view.jsx